import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'app/baseQuery';
import { apiTags } from 'app/store/apiTags';

const apiPrefix = 'washProgram';

export const washProgramApi = createApi({
    reducerPath: 'washProgramApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getSlaCycleDefinition: builder.query({
            query: (clientId) => `${apiPrefix}/cycle?clientId=${clientId}`,
            providesTags: [apiTags.SLA_CYCLE_DEFINITION],
        }),
        saveWashProgramConfig: builder.mutation({
            query: (body) => ({
                url: apiPrefix,
                method: 'POST',
                body,
            }),
            invalidatesTags: [apiTags.SLA_CYCLE_DEFINITION, apiTags.CLIENT_CONFIG],
        }),
        getLastCycleLotsCompliance: builder.query({
            query: (clientId) => `${apiPrefix}/lastCycleLotsCompliance?clientId=${clientId}`,
            providesTags: [apiTags.SLA_COMPLIANCE],
        }),
        getLastCycleInstancesData: builder.query({
            query: (clientId) => `${apiPrefix}/lastCycleInstancesData?clientId=${clientId}`,
            providesTags: [apiTags.SLA_COMPLIANCE],
        }),
    }),
});

export const {
    useGetSlaCycleDefinitionQuery,
    useSaveWashProgramConfigMutation,
    useGetLastCycleLotsComplianceQuery,
    useGetLastCycleInstancesDataQuery
} = washProgramApi;
